import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class EventsService {
  private ahuChangedEventSubject = new Subject<string>()

  private projectChangedEventSubject = new Subject<string>()

  ahuChangedEvent$ = this.ahuChangedEventSubject.asObservable()

  projectChangedEvent$ = this.projectChangedEventSubject.asObservable()

  ahuChanged(ahuId: string): void {
    this.ahuChangedEventSubject.next(ahuId)
  }

  projectChanged(projectId: string): void {
    this.projectChangedEventSubject.next(projectId)
  }
}
